import { environment } from '../../../environments/environment';

const isProduction = environment.production;

export function logDebug(...args: unknown[]): void {
  if (!isProduction) {
    console.log(...args);
  }
}

export function logWarn(...args: unknown[]): void {
  if (!isProduction) {
    console.warn(...args);
  }
}

export function logError(...args: unknown[]): void {
  console.error(...args);
}
